/**
 * Sky-X new SFX / BGM paths (public/games/skyx_new/sfx/MP3 + sfx/OGG).
 * Change filenames here to swap assets without touching game logic.
 */
export const SKYX_NEW_SOUND_MAP: Record<string, string> = {
  bet: 'sfx/MP3/button_click.mp3',
  cashout: 'sfx/MP3/cash_out.mp3',
  start: 'sfx/MP3/takeoff_5.mp3',
  crash: 'sfx/MP3/blast.mp3',
  bgMusic: 'sfx/MP3/bgm_loop.mp3',
  win: 'sfx/MP3/win.mp3',
  autoPlay: 'sfx/MP3/auto_play.mp3',
  transition: 'sfx/MP3/transition.mp3',
  flyby: 'sfx/MP3/flyby.mp3',
  windLoop: 'sfx/MP3/wind_loop.mp3',
  cancelPopup: 'sfx/MP3/cancel_popup.mp3',
  type1: 'sfx/MP3/type_1.mp3',
  counterLoop: 'sfx/MP3/sx_counter_loop.mp3',
};

export type SkyxNewSoundKey = keyof typeof SKYX_NEW_SOUND_MAP;

/**
 * Per-sound Howler volume (0–2+). Values match current HowlerBackend defaults
 * for sky-x new — tweak here without touching core audio code.
 */
export const SKYX_NEW_SOUND_VOLUMES: Record<SkyxNewSoundKey, number> = {
  bet: 0.8,
  cashout: 0.75,
  start: 1.75,
  crash: 1.0,
  bgMusic: 0.2,
  win: 0.7,
  autoPlay: 0.35,
  transition: 0.35,
  flyby: 0.35,
  windLoop: 1.00,
  cancelPopup: 0.35,
  type1: 1.0,
  counterLoop: 0.8,
};

/** Default SFX volume when no explicit entry exists (HowlerBackend fallback). */
export const SKYX_NEW_SOUND_DEFAULT_VOLUME = 0.35;

/** SFX when the jet rolls on the runway (WAITING phase start). */
export const SKYX_NEW_RUNWAY_ROLL_SOUND = 'start' as const;

/** Toggle runway / flyby roll SFX on WAITING (sky-x new only). */
export const SKYX_NEW_RUNWAY_ROLL_SOUND_ENABLED = true;

/**
 * @deprecated Use `PLANE_CRASH_ANIMATION.blastSoundDelayMs` in
 * `src/games/skyx_new/configs/VisualConfig.ts` for crash animation/audio sync.
 */
export const SKYX_NEW_CRASH_BLAST_SOUND_DELAY_MS = 0;

export const SKYX_NEW_WIND_LOOP_AFTER_TAKEOFF_GAP_MS = 0;

/** Loop SFX while holding stake +/- (sky-x new long-press repeat). */
export const SKYX_NEW_STAKE_COUNTER_LOOP_SOUND = 'counterLoop' as const;

/** Preload list for manifest.json (MP3 primary paths). */
export const SKYX_NEW_SOUND_PRELOAD_PATHS = Object.values(SKYX_NEW_SOUND_MAP);

/** Fallback flyby / runway-roll clip length (sec) until Howler reports duration. */
export const RUNWAY_TAKEOFF_SOUND_FALLBACK_SEC = 8;
